<template>
  <div class="af3-shortcodes-single-vr-component">
    <iframe class="af3-shortcodes-single-vr-component-iframe" v-if="floor_plan.virtual_tour_url" :src="floor_plan.virtual_tour_url" frameborder="0"></iframe>

  </div>
</template>
  
<script>

import { defineComponent, ref, watch, onMounted, reactive  } from 'vue';


export default defineComponent({
    components: { },
   
    props: { 
        options: {
            type: Object,
            required: true
        },
        floor_plan: {
            type: Object,
            required: true
        }
    },

    setup(props) {

        onMounted(() => {
            console.log(props.floor_plan);
        });

    return {
        
    };
  },


  
  
});
</script>